import { NamedObject } from '@faro/study-designer-model';
import { Option } from '@faro/design-system';

export const namedObjectToIdOption = (namedObject: NamedObject): Option<string> => ({
    key: namedObject.id,
    label: namedObject.name,
    value: namedObject.id || '',
});
